module.exports = __webpack_public_path__ + "bc616b8f6bf3d673c22e0e910adcf7fd.jpg";